import React, { useState, useEffect } from "react";
import DynamicFormMain from '../components/Profile&Settings/CommunityProfile/DynamicFormMain';
import { useAuthContext } from "../hooks/useAuthContext";

const ProfileUpdate = () => {
  const { user } = useAuthContext();
  const [communityNames, setCommunityNames] = useState([]);
  const [selectedCommunityIndex] = useState(0); // No setter needed as in your example

  useEffect(() => {
    // Optional: log user or community info for debugging
    if (user) {
      console.log("[ProfileUpdate] User loaded:", {
        userId: user.userId,
        communityCount: user.listOfCommunities?.length || 0
      });
    }
  }, [user]);

  const handleCommunityName = (communityName, index) => {
    setCommunityNames(prevNames => {
      const newNames = [...prevNames];
      newNames[index] = communityName;
      return newNames;
    });
  };

  if (!user || !Array.isArray(user.listOfCommunities) || user.listOfCommunities.length === 0) {
    return <div>Loading user or communities...</div>;
  }

  const communityId = user.listOfCommunities[selectedCommunityIndex]?._id 
                   || user.listOfCommunities[selectedCommunityIndex];

  return (
    <div style={{ padding: 32 }}>
      <DynamicFormMain
        user={user}
        communityId={communityId}
        onCommunityName={(name) => handleCommunityName(name, selectedCommunityIndex)}
        setCommunityProfileComplete={() => {}}
        mode={"settings"}
      />
    </div>
  );
};

export default ProfileUpdate;

// import React, { useState, useEffect } from "react";
// import CommunityProfileMain from "../components/Profile&Settings/CommunityProfile/CommunityProfileMain";
// import { useAuthContext } from "../hooks/useAuthContext";

// const Tester1 = () => {
//   const { user } = useAuthContext();
//   const [communityNames, setCommunityNames] = useState([]);
//   const [selectedCommunityIndex] = useState(0); // Removed setter since it's not used

//   // Log initial props/state
//   useEffect(() => {
//     console.log("[Tester1] Component mounted");
//     return () => console.log("[Tester1] Component unmounted");
//   }, []);

//   // Log user changes
//   useEffect(() => {
//     if (user) {
//       console.log("[Tester1] User loaded:", {
//         userId: user.userId,
//         communityCount: user.listOfCommunities?.length || 0
//       });
//     }
//   }, [user]);

//   const handleCommunityName = (communityName, index) => {
//     console.log("[Tester1] Received community name update:", {
//       index,
//       name: communityName,
//       previousName: communityNames[index]
//     });
    
//     setCommunityNames(prevNames => {
//       const newNames = [...prevNames];
//       newNames[index] = communityName;
//       console.log("[Tester1] Updated community names:", newNames);
//       return newNames;
//     });
//   };
 
//   if (!user || !Array.isArray(user.listOfCommunities) || user.listOfCommunities.length === 0) {
//     console.log("[Tester1] Waiting for user data or communities");
//     return <div>Loading user or communities...</div>;
//   }


// const communityId = user.listOfCommunities[selectedCommunityIndex]?._id 
//                    || user.listOfCommunities[selectedCommunityIndex];
// console.log("[Tester1] Derived community ID:", {
//   index: selectedCommunityIndex,
//   communityId,
//   rawData: user.listOfCommunities[selectedCommunityIndex], // Log actual data structure
//   totalCommunities: user.listOfCommunities.length
// });

//   return (
//     <div style={{ padding: 32 }}>
//       <CommunityProfileMain
//         user={user}
//         communityId={communityId}
//         onCommunityName={(name) => {
//           console.log("[Tester1] Passing name to handler:", name);
//           handleCommunityName(name, selectedCommunityIndex);
//         }}
//       />
//       {/* <div style={{ marginTop: 16 }}>
//         <strong>Current Community Name:</strong>{" "}
//         {communityNames[selectedCommunityIndex] || "Not set yet"}
//       </div> */}
//     </div>
//   );
// };

// export default Tester1;
